import * as d3 from 'd3-selection'

export default function (selection) {
  selection.each(function () {
    var suggestion = d3.select(this)
                       .selectAll('.select-menu-help')
                       .data(function (d) {
                         return d.filterable && d.filterSuggestion ? [d.filterSuggestion] : []
                       })
      , enter = suggestion.enter()
                          .append('div')
                            .attr('class', 'select-menu-help')

    suggestion.raise() // Make sure the suggestion is the last item in the list
                       // of all the results

    enter.append('svg')
           .attr('class', 'icon-dots')
           .attr('viewBox', '0 0 18 4')
           .append('path')
             .attr('d', 'M2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0C7.9 0 7 .9 7 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z')
    enter.append('span')

    enter.merge(suggestion)
         .select('span')
           .text(String)

    suggestion.exit().remove()
  })
}
